import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class StripeConnectResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/stripe_connects' as const;

  readonly id: number | undefined = undefined;
  
  pk() {
    return this.id?.toString();
  }
}
